Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Header688719414",
  {"root":"Header688719414--root","title":"Header688719414--title","subtitle":"Header688719414--subtitle"},
  ".Header688719414--title{width:100%}.Header688719414--subtitle{width:100%}",
  4,
  "Header688719414"
);
__webpack_require__.stylable.$.register(exports.default)
